/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { createSlice } from '@reduxjs/toolkit';

import { NameSpace } from '@/constant/store';

import { UserProcess } from '@/types/user-process';

const initialState: UserProcess = {
	from: null,
	isFullDay: false,
	hours: 2,
	minutes: 0,
	user: null,
	person: null,
	clientId: null,
	replacedPersonId: null,
	passes: [],
	passId: null,
	isActiveBookingShown: false,
};

export const userProcess = createSlice({
	name: NameSpace.user,
	initialState,
	reducers: {
		setUser: (state, action) => {
			state.user = action.payload;
		},
		setPerson: (state, action) => {
			state.person = action.payload;
		},
		setClientId: (state, action) => {
			state.clientId = action.payload;
		},
		setReplacedPersonId: (state, action) => {
			state.replacedPersonId = action.payload;
		},
		setPasses: (state, action) => {
			state.passes = action.payload;
		},
		setPassId: (state, action) => {
			state.passId = action.payload;
		},
		setFrom: (state, action) => {
			state.from = action.payload;
		},
		setIsFullDay: (state, action) => {
			state.isFullDay = action.payload;
		},
		setHours: (state, action) => {
			state.hours = action.payload;
		},
		setMinutes: (state, action) => {
			state.minutes = action.payload;
		},
		showActiveBooking: (state, { payload }) => {
			state.isActiveBookingShown = payload;
		},
	},
});

export const {
	setFrom,
	setIsFullDay,
	setHours,
	setMinutes,
	setClientId,
	setReplacedPersonId,
	setPasses,
	setPassId,
	setUser,
	setPerson,
	showActiveBooking,
} = userProcess.actions;
